<template>
  <section class="order-status-content">
    <div class="container">
      <div class="row">
        <div class="col-sm-4">
          <h1>{{ orderStatus }}</h1>
          <component :is="statusComponentName" :order="order" :product="product" />

        </div>
        <div class="col-sm-4 offset-sm-4">
          <order-status-graphic :order="order" :product="product"/>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import OrderStatusGraphic from "./order-status-graphic";
import orderStatusHelper from "../../helpers/order-status";

export default {
  name: "order-status-content",
  components: {OrderStatusGraphic},
  props: [
    'order',
    'product'
  ],
  data() {
    return {orderStatusHelper};
  },
  computed: {
    orderStatus() {
      return orderStatusHelper.origoStatusToStatusTitle(
        orderStatusHelper.key2StatusToOrigoStatus(this.order.orderStatusDescription, false)
      );
    },
    statusComponentName() {
      return orderStatusHelper.key2StatusToOrigoStatus(this.order.orderStatusDescription, false).toLowerCase();
    }
  }
}
</script>

<style scoped>
.order-status-content {
  background: #fff;
  padding: 4rem 0;
}
</style>
